module.exports = __webpack_public_path__ + "static/media/police.e3a04103.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/police.png
 ** module id = 468
 ** module chunks = 0
 **/